import * as React from 'react';
import { TextField, FormControl } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { IXpresWashConfig } from '../../_types/location';

interface Props {
    classes: any;
    /** the item to display */
    item: IXpresWashConfig;
    onChange: (config: any) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const XpresWashConfig: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();

    return (
    <Grid container direction="row" alignItems="center">
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="Location Id" value={prop.item.LocationId} onChange={(e) => {let i = prop.item; i.LocationId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="System Id" value={prop.item.SystemId} onChange={(e) => {let i = prop.item; i.SystemId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="Lane Id" value={prop.item.LaneId} onChange={(e) => {let i = prop.item; i.LaneId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="User Name" value={prop.item.Username} onChange={(e) => {let i = prop.item; i.Username = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
        <FormControl className={classes.formControl}>
                <TextField label="Password" value={prop.item.Password} onChange={(e) => {let i = prop.item; i.Password = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
    </Grid>
    );
}

export default XpresWashConfig;